// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.department .sk-input {\n  margin-bottom: 0;\n  background-color: #fff;\n  font-weight: normal;\n  font-size: 13px;\n}\n.department {\n  width: 100%;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
